module.exports = __webpack_public_path__ + "img/hero.ecc14dbd.jpg";